import { useState } from 'react';
import { Lock, Sparkles, X } from 'lucide-react';

/**
 * Section désactivée au niveau boutique (ex. gestion des stocks non activée).
 * Même UX que PremiumFeatureCard, sans notion de permission.
 */
export default function DisabledServiceFeatureCard({
  title,
  icon = '📦',
  description,
  features = [],
  contactMessage = 'Contactez votre administrateur Clickorico pour activer cette section pour votre boutique.',
  settingsHint = null,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        className="relative bg-gradient-to-br from-yellow-50 via-white to-blue-50 rounded-xl p-6 border-2 border-yellow-300 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group overflow-hidden"
        onClick={() => setShowModal(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setShowModal(true)}
      >
        <div className="absolute top-3 right-3 flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white text-xs font-semibold rounded-full shadow-md">
          <Sparkles className="h-3 w-3" />
          <span>Option à activer</span>
        </div>

        <div className="pr-24">
          <div className="flex items-center gap-3 mb-3">
            <div className="text-4xl">{icon}</div>
            <div>
              <h3 className="text-lg font-bold text-gray-900">{title}</h3>
              <p className="text-sm text-gray-600 mt-1">{description}</p>
            </div>
          </div>

          {features.length > 0 && (
            <div className="mt-4">
              <p className="text-xs font-medium text-gray-500 mb-2">Fonctionnalités incluses :</p>
              <ul className="text-sm text-gray-700 space-y-1">
                {features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <span className="text-yellow-500">•</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="mt-5 -mx-6 px-6 pt-4 border-t border-yellow-200">
          <button
            type="button"
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-white font-medium py-2.5 rounded-lg hover:from-yellow-500 hover:to-yellow-700 transition-all duration-200 flex items-center justify-center gap-2"
          >
            <Lock className="h-4 w-4" />
            <span>Activer cette section</span>
          </button>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-gradient-to-r from-yellow-400 to-yellow-600 px-6 py-4 flex items-center justify-between rounded-t-xl">
              <div className="flex items-center gap-3">
                <div className="text-3xl">{icon}</div>
                <h3 className="text-xl font-bold text-white">{title}</h3>
              </div>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-1 transition"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="p-6">
              <p className="text-gray-700 mb-4">{description}</p>

              <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4 mb-4">
                <p className="text-sm text-gray-700 mb-2">{contactMessage}</p>
                {settingsHint && (
                  <p className="text-xs text-gray-600">{settingsHint}</p>
                )}
              </div>

              <div className="flex gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="flex-1 btn-secondary">
                  Fermer
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowModal(false);
                    alert(contactMessage);
                  }}
                  className="flex-1 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white font-medium py-2.5 rounded-lg hover:from-yellow-500 hover:to-yellow-700 transition-all"
                >
                  Comprendre
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
